import StoreDemoControlUnitsListGrid from '../../../../../customized/store-demo/components/DeviceManager/ControlUnit/ControlUnitList/StoreDemoControlUnitsListGrid';
import { ToggleComponent } from '../../../../../featureToggle';
import ControlUnitsListGrid from './ControlUnitsListGrid';

export default ToggleComponent(ControlUnitsListGrid, {
  styledComponentsVariants: {
    techdays: StoreDemoControlUnitsListGrid,
  },
});
